import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const cMAdvancedKeywordsApi = createApi({
  reducerPath: 'cMAdvancedKeywordsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['CampaignAdvancedKeywords'],
  endpoints: (builder) => ({
    getCampaignAdvancedKeywords: builder.query({
      query: (params) => ({
        url: '/campaigns/campaign-advanced-keywords/',
        method: 'GET',
        params,
      }),
      providesTags: ['CampaignAdvancedKeywords'],
    }),
    createCampaignAdvancedKeyword: builder.mutation({
      query: (body) => ({
        url: '/campaigns/campaign-advanced-keywords/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CampaignAdvancedKeywords'],
    }),
    updateCampaignAdvancedKeyword: builder.mutation({
      query: ({ id, body }) => ({
        url: `/campaigns/campaign-advanced-keywords/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['CampaignAdvancedKeywords'],
    }),
    deleteCampaignAdvancedKeyword: builder.mutation({
      query: (id) => ({
        url: `/campaigns/campaign-advanced-keywords/${id}/`,
        method: 'DELETE',
        
      }),
      invalidatesTags: ['CampaignAdvancedKeywords'],
    }),
  }),
});

export const {
  useGetCampaignAdvancedKeywordsQuery,
  useLazyGetCampaignAdvancedKeywordsQuery,
  useCreateCampaignAdvancedKeywordMutation,
  useDeleteCampaignAdvancedKeywordMutation,
  useUpdateCampaignAdvancedKeywordMutation
} = cMAdvancedKeywordsApi;